import axios from './api'

/* 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */

// 单独导出
export const getNotices = () => {
	return axios({
		url: '/index/getNotices',
		method: 'get'
	})
}
export const getBanner = () => {
	return axios({
		url: '/index/getBanner',
		method: 'get'
	})
}
export const getLottoDetail = datas => {
	return axios({
		url: '/index/getLottoDetail',
		method: 'get',
		params: datas
	})
}
export const getDewDrop = datas => {
	return axios({
		url: '/index/DewDrop',
		method: 'get',
		params: datas
	})
}
export const getLongQueue = datas => {
	return axios({
		url: '/Longqueue/index',
		method: 'get',
		params: datas
	})
}
export const getLongQueueList = () => {
	return axios({
		url: '/Longqueue/lottoList',
		method: 'get',
	})
}
export const getNews = datas => {
	return axios({
		url: '/News/getNews',
		method: 'get',
		params: datas
	})
}
export const getNewsDetail = datas => {
	return axios({
		url: '/News/getNewsDetail',
		method: 'get',
		params: datas
	})
}
export const getAdvert = () => {
	return axios({
		url: '/index/getAdvert',
		method: 'get',
	})
}
export const getTop = () => {
	return axios({
		url: '/News/getTop',
		method: 'get',
	})
}
export const getChart = datas => {
	return axios({
		url: '/index/index',
		method: 'get',
		params: datas
	})
} 
export const getKaiPan = datas => {
	return axios({
		url: '/index/getkaipan',
		method: 'post',
		data: datas
	})
}
// 默认全部导出
export default {
    getNotices,getBanner,getLottoDetail,getDewDrop,getLongQueue,getLongQueueList,getNews,getNewsDetail,getAdvert,getTop,getChart,getKaiPan
}


// WEBPACK FOOTER //
// ./src/http/interface.js